import { motion } from "framer-motion";
import { Reveal } from "@/components/common/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Notre vision",
    text: "Faire de la formation transport une expérience premium, exigeante et humaine, au service de la sécurité routière et de la réussite de chaque apprenant.",
  },
  {
    n: "02",
    title: "Notre mission",
    text: "Accompagner les futurs conducteurs et enseignants de la conduite vers des qualifications reconnues, du permis aux titres professionnels inscrits au RNCP.",
  },
  {
    n: "03",
    title: "Notre engagement",
    text: "Des formateurs experts, des moyens matériels performants et innovants, et un accompagnement personnalisé sur le financement de votre parcours.",
  },
];

export default function Presentation() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="presentation">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-red">
              Le Groupe
            </span>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-brand-blue sm:text-4xl">
              Un regroupement d'organismes de formation dédié aux métiers de la route et de la mobilité
            </h2>
            <p className="mt-5 text-slate-500">
              EDUCASER GROUP réunit des centres spécialisés dans le transport de marchandises,
              de voyageurs et l'enseignement de la conduite.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-px">
              {CHAPTERS.map((c, i) => (
                <Reveal
                  key={c.n}
                  delay={i * 0.1}
                  className="group grid grid-cols-1 gap-4 border-t border-slate-200 py-8 transition-colors sm:grid-cols-12 sm:items-baseline"
                >
                  <span className="font-display text-2xl font-bold text-brand-red sm:col-span-2">
                    {c.n}
                  </span>
                  <h3 className="font-display text-xl font-bold text-brand-blue sm:col-span-3">
                    {c.title}
                  </h3>
                  <motion.p className="text-slate-600 sm:col-span-7">{c.text}</motion.p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
